export const ResaleCertificateForm = {
  model: 'Supplier',
  format: [
    {
      widths: 'equal',
      fields: {
        resale_certificate: {
          type: 'file',
        },
      },
    },
  ],
}
